import { render, staticRenderFns } from "./news-list.html?vue&type=template&id=2cf3986a&scoped=true&external"
import script from "./news-list.js?vue&type=script&lang=js&external"
export * from "./news-list.js?vue&type=script&lang=js&external"
import style0 from "./news-list.scss?vue&type=style&index=0&id=2cf3986a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3986a",
  null
  
)

export default component.exports